import { render, staticRenderFns } from "./Vlan.vue?vue&type=template&id=7732b70a&"
import script from "./Vlan.vue?vue&type=script&lang=js&"
export * from "./Vlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports